export const MENU_SECTIONS = [{
        section: null, // no section title (top-level pinned)
        items: [
            { key: 'dashboard', label: 'Dashboard', icon: '⊞', permission: 'dashboard:read' },
            { key: 'dashboard-client', label: 'Dashboard Financier', icon: '📊', permission: 'dashboard:read' },
            { key: 'dashboard-vehicule', label: 'Dashboard Flotte', icon: '🚚', permission: 'dashboard:read' },
            { key: 'dashboard-equipe', label: 'Performance Équipes', icon: '⚡', permission: 'dashboard:read' },
            { key: 'dashboard-produits-clients', label: 'Produits & Clients', icon: '', permission: 'dashboard:read' },
            { key: 'dashboard-bons-livraison', label: 'Bons de Livraison', icon: '', permission: 'documents:read' },
        ],
    },
    {
        section: 'Dashboard Clients',
        items: [
            { key: 'dashboard-clients', label: 'Tableau de bord', icon: '📊', permission: 'dashboard:read' },
        ],
    },
    {
        section: 'CRM & Ventes',
        items: [
            { key: 'clientsmanagement', label: 'Clients', icon: '', permission: 'clients:read' },
            { key: 'prospects', label: 'Prospects', icon: '', permission: 'prospects:read' },
            { key: 'commerciaux', label: 'Commerciaux', icon: '', permission: 'commerciaux:read' },
            { key: 'commercial-commissions', label: 'Commissions', icon: '', permission: 'commerciaux:read' },
            { key: 'historique-notes', label: 'Historique des Notes', icon: '📋', permission: 'clients:read' },
            { key: 'demandesdevis', label: 'Devis', icon: '', permission: 'devis:read' },
            { key: 'reclamationsAdmin', label: 'Réclamations', icon: '', permission: 'reclamations:read' },
        ],
    },
    {
        section: 'Stock & Logistique',
        groupKey: 'stock',
        items: [
            { key: 'produitsAdmin', label: 'Produits', icon: '', permission: 'produits:read' },
            { key: 'packsAdmin', label: 'Packs Produits', icon: '', permission: 'produits:read' },
            { key: 'stockmanagement', label: 'Gestion Stock', icon: '', permission: 'stock:read' },

            { key: 'stockstatus', label: 'Gestion des Palettes', icon: '', permission: 'stock:read' },
            { key: 'inventaire', label: 'Inventaire', icon: '', permission: 'stock:read' },
            { key: 'mouvements-inventaire', label: 'Historique Mouvements', icon: '📝', permission: 'stock:read' },
            { key: 'warehouse3d', label: 'Garage 3D', icon: '', permission: 'stock:read' },
        ],
    },
    {
        section: 'Partenaires & Réseau',
        items: [
            { key: 'fournisseurs', label: 'Fournisseurs', icon: '', permission: 'fournisseurs:read' },
            { key: 'equipes-installation', label: 'Équipes Installation', icon: '', permission: 'equipes_installation:read' },
            { key: 'steg', label: 'STEG', icon: '', permission: 'clients:read' },
            { key: 'contacts', label: 'Contacts & Types', icon: '', permission: 'utilisateurs:read' },
            { key: 'locations', label: 'Bureaux & Partenaires', icon: '', permission: 'partenaires:read' },
        ],
    },
    {
        section: 'Contenu & Site',
        items: [
            { key: 'actualites-newsletter', label: 'Actualités & Newsletter', icon: '📰' },
            { key: 'referencesAdmin', label: 'Références', icon: '', permission: 'references:read' },
            { key: 'region', label: 'Régions', icon: '', permission: 'dashboard:read' },
            { key: 'entreprises', label: 'Entreprises', icon: '', permission: 'utilisateurs:read' },
            { key: 'heroimages', label: 'Images Hero', icon: '', permission: 'dashboard:read' },
        ],
    },
    {
        section: 'Ressources Humaines',
        items: [
            { key: 'gestion-rh', label: 'Gestion RH', icon: '👥', permission: 'rh:read' },
        ],
    },
    {
        section: 'Administration',
        items: [
            { key: 'usermanagements', label: 'Utilisateurs', icon: '', permission: 'utilisateurs:read' },
            { key: 'deletion-settings', label: 'Actions & Données Sensibles', icon: '🛡️', permission: 'utilisateurs:read' },
            { key: 'archived-items', label: 'Éléments Archivés', icon: '📦', permission: 'clients:read' },
            { key: 'audit-logs', label: 'Audit Trail', icon: '🛡️', permission: 'dashboard:read' },
            { key: 'cloture-periode', label: 'Clôture de Période', icon: '🔒', permission: 'dashboard:read' },
            { key: 'profileadmin', label: 'Mon Profil', icon: '' },
        ],
    },
];

export const getFirstAllowedBackOfficePage = (typeUser, permissions = []) => {
    if (typeUser === 'admin') return 'dashboard';
    if (typeUser !== 'moderateur') return null;

    for (const section of MENU_SECTIONS) {
        for (const item of section.items) {
            if (!item.permission) return item.key;
            const [module, action] = item.permission.split(':');
            if (permissions.includes(`${module}:${action || 'read'}`)) {
                return item.key;
            }
        }
    }
    return 'profileadmin'; // Fallback to profile which usually doesn't need specific module perm if you are admin/mod
};